import { components } from "./ApiSchema";
import useUpdatePart from "./queries/useUpdatePart";
import { useState } from "react";
import toast from "react-hot-toast";
import { getFullOperationsWidth } from "./utils";

export default function PartNote({
  part,
  quantities,
}: {
  part: components["schemas"]["RequestedPartWithOperationsSchema"];
  quantities: number[];
}) {
  const width = getFullOperationsWidth(quantities.length);
  const { updatePart } = useUpdatePart();
  const [note, setNote] = useState(part.note || "");

  return (
    <div style={{ width: `${width}px` }} className="text-xs">
      <textarea
        rows={2}
        onChange={(e) => setNote(e.target.value)}
        className="border rounded-md p-2 w-full"
        value={note}
        placeholder="Add notes to estimate (prints on quote)"
        onBlur={(e) => {
          if (e.target.value === part.note) return;

          updatePart({
            payload: { note },
            onSuccess: () => {
              toast.success("Note saved");
            },
          });
        }}
      />
    </div>
  );
}
